<template>
    <span class="star">
        <i class="iconfont icon-star-1" v-for="i in level" :key="i"></i>
        <!--v-for="j in (max - level)" v-if="max > level"-->
        <template v-if="max > level">
            <i class="iconfont icon-star-1 disabled" v-for="j in (max - level)" :key="'j' + j"></i>
        </template>
    </span>
</template>
<script>
export default {
    name: "star",
    data() {
        return {
            max: 5
        };
    },
    props: {
        level: {
            type: [String, Number],
            default: 5
        }
    }
};
</script>
<style scoped lang="scss">
@import "../sass/fonts/iconfont.css";
@import "../sass/variables";

.star {
    white-space: nowrap;
    line-height: 14px;
    i {
        color: $yellow;
        font-size: 14px;
        margin-right: 5px;
    }
    .disabled {
        color: rgba($yellow, 0.2);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Star.vue